/* eslint-disabled */

export default class AssetExtend {


  constructor (object?: any) {
  }

  postConstruct () {
  }
}
